export const LOCAL_STORAGE = {
  USER_INFO: "userInfo",
  CURRENT_USER: "currentUser",
  DATASOURCE_LIST: "datasourceList",
  PROJECT_LIST: "projects",
  DATADOG_CODE_VERIFIER: "datadogCodeVerifier",
  REDIRECT_URI: "redirectUri",
};

export const LANGUAGES = {
  EN: "en",
  FR: "fr",
};
export const LOCALE = {
  IN: "en-IN",
  US: "en-US",
};
export const DEFAULT_LOCALE_CONST = {
  LANG: "defaultLanguage",
  CURRENCY: "defaultCurrency",
  LOCALE: "defaultLocale",
};
export const ROUNDING_MODE = {
  ROUND: Math.round,
  FLOOR: Math.floor,
  CEIL: Math.ceil,
};

export const INPUT_STYLE_TYPE = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
};

export const INPUT_NUMBER_STYLE_TYPE = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
};

export const AUTOCOMPLETE_STYLE_TYPE = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
};

export const OTP_STYLE_TYPE = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
};

export const LABEL_STYLE_TYPE = {
  PRIMARY: "PRIMARY",
  RIGHT: "RIGHT",
};

export const DROPDOWN_STYLE_TYPE = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
  TERTIARY: "TERTIARY",
  QUATERNARY: "QUATERNARY",
};

export const INPUT_ERROR_TYPE = {
  BORDER: "BORDER",
  DEFAULT: "DEFAULT",
};

export const LIMIT_TYPE = {
  DAILY: "DAILY",
  WEEKLY: "WEEKLY",
  MONTHLY: "MONTHLY",
};

export const CHECKBOX_STYLE_TYPE = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
};
export const TOAST_VARIANT = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
  TERTIARY: "TERTIARY",
  QUATERNARY: "QUATERNARY",
};
export const TOAST_STYLE_TYPE = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
  TERTIARY: "TERTIARY",
  QUATERNARY: "QUATERNARY",
};

export const BUTTON_STYLE_TYPE = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
};

export const COLOR_STYLE_TYPE = {
  RED: "RED",
  GRAY: "GRAY",
  PLUM: "PLUM",
};

export const LOADER_POSITION = {
  RIGHT: "right",
  LEFT: "left",
};
export const MIME_TYPE = {
  JSON: "application/json",
  PLAIN: "text/plain",
};

export const IS_ROUTE_GUARD = {
  Y: "Y",
  N: "N",
};

// ENVIRONMENT VARIABLE CONSTANTS
export const ENV_VAR = {
  VITE_BASE_API_URL: "VITE_BASE_API_URL",
  VITE_ENABLE_PWA_MODE: "VITE_ENABLE_PWA_MODE",
  VITE_IS_ACL_ENABLED: "VITE_IS_ACL_ENABLED",
  VITE_IS_ROUTE_GUARD: "VITE_IS_ROUTE_GUARD",
  VITE_SHOW_LOGS: "VITE_SHOW_LOGS",
  VITE_GOOGL_MAP_KEY: "VITE_GOOGL_MAP_KEY",
  VITE_SHOULD_PERSIST: "VITE_SHOULD_PERSIST",
  VITE_PERSIST_STORAGE: "VITE_PERSIST_STORAGE",
  VITE_PERSIST_STORAGE_SECRET: "VITE_PERSIST_STORAGE_SECRET",
  VITE_MICROSOFT_CLIENT_ID: "VITE_MICROSOFT_CLIENT_ID",
  VITE_MICROSOFT_TENANT_ID: "VITE_MICROSOFT_TENANT_ID",
  VITE_MASTER_SUBSCRIPTION_AGREEMENT_LINK: "VITE_MASTER_SUBSCRIPTION_AGREEMENT_LINK",
  VITE_GITHUB_APP_INSTALLATION_LINK: "VITE_GITHUB_APP_INSTALLATION_LINK",
  VITE_AWS_OIDC_AUTHORIZATION_URL: "VITE_AWS_OIDC_AUTHORIZATION_URL",
  VITE_AWS_OIDC_CLIENT_ID: "VITE_AWS_OIDC_CLIENT_ID",
  VITE_ENABLE_CHANGE_API_URL: "VITE_ENABLE_CHANGE_API_URL",
  VITE_DISABLE_AUTO_GENERATION: "VITE_DISABLE_AUTO_GENERATION",
  VITE_DISABLE_AWS_OIDC_FORM: "VITE_DISABLE_AWS_OIDC_FORM",
  VITE_CONFIGCAT_SDK_KEY: "VITE_CONFIGCAT_SDK_KEY",
  VITE_CONFIGCAT_POLL_INTERVAL: "VITE_CONFIGCAT_POLL_INTERVAL",
  VITE_ORG_NAME: "VITE_ORG_NAME",
  VITE_CLUSTER: "VITE_CLUSTER",
  VITE_DOCS_BOT_ID: "VITE_DOCS_BOT_ID",
  VITE_AUTO_REDIRECT_FOR_AUTH0: "VITE_AUTO_REDIRECT_FOR_AUTH0",
};

export enum PERSIST_STORAGES {
  INDEX_DB = "INDEX_DB",
  LOCAL_STORAGE = "LOCAL_STORAGE",
  SESSION_STORAGE = "SESSION_STORAGE",
  CUSTOM = "CUSTOM",
}

export enum STEP_STATUS {
  ACTIVE = "active",
  COMPLETED = "completed",
  PENDING = "pending",
  FAILED = "failed",
}

// FILE_UPLOAD_STATUS_UNSPECIFIED: File upload status is unspecified.
// FILE_UPLOAD_STATUS_IN_PROGRESS: File upload is in progress.
// FILE_UPLOAD_STATUS_COMPLETE: File upload is complete.
// FILE_UPLOAD_STATUS_FAILED: File upload failed.

export enum FILE_STATUS {
  UNSPECIFIED = "FILE_UPLOAD_STATUS_UNSPECIFIED",
  IN_PROGRESS = "FILE_UPLOAD_STATUS_IN_PROGRESS",
  COMPLETE = "FILE_UPLOAD_STATUS_COMPLETE",
  FAILED = "FILE_UPLOAD_STATUS_FAILED",
  UPLOADING = "FILE_UPLOAD_STATUS_UPLOADING",
}

export enum HAWKEYE_STATUS {
  INVESTIGATION_IN_PROGRESS = "INVESTIGATION_IN_PROGRESS",
  INVESTIGATION_COMPLETED = "INVESTIGATION_COMPLETED",
  RCA_READY = "RCA_READY",
  // RCA_IN_PROGRESS = "RCA_IN_PROGRESS",
  // RCA_COMPLETED = "RCA_COMPLETED",
}

export enum TOOL_STATUS {
  IN_PROGRESS = "IN_PROGRESS",
  TRIGGERED = "TRIGGERED",
  RESOLVED = "RESOLVED",
}
